<template>
    <div class="attendance-container p-4 shadow-lg rounded">
        <h2 class="text-xl font-bold mb-4">Attendance</h2>
        <hr />
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <input type="date" v-model="date" class="border  p-2 rounded" style="max-width: 300px;" />
            <!-- <select v-model="selectedCounselor" class="border p-2 rounded me-2" style="max-width: 300px;width: 300px;">
                <option disabled value="">Select Counselor</option>
                <option v-for="counselor in counselors" :key="counselor" :value="counselor.id">{{ counselor.user?.name
                    }}</option>
            </select> <br> -->
            <select v-model="selectedGroup" class="border p-2 mt-2 rounded" style="max-width: 300px;width:300px;">
                <option value="0">Select Group</option>
                <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
            </select>
        </div>

        <button class="btn btn-sm add-btn" @click="loadAttendance">Load Attendance</button>
        <button class="btn btn-sm add-btn ms-2" @click="takeAttendance">Take Attendance</button>
        <!-- <hr> -->
        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <!-- <table v-else class="table table-bordered">

            <tr>
                <th>#</th>
                <th>Name</th>
                <th>DOB</th>
                <th>Date</th>
                <th>Signature By Student</th> -->
        <!-- <th>Timestamp</th> -->
        <!-- </tr>

            <tr v-for="(student, index) in attendanceData.students" v-bind:key="student.id">
                <td>{{ index + 1 }}</td>
                <td>{{ student.user?.name }}</td>
                <td>{{ $formatDate(student.dob) }}</td>
                <td>{{ }}</td>
                <td>
                    <img :src="student.signature_url" style="width: 200px;"
                        v-if="attendanceData.attendanceRecords[student.id]" alt="present" />
                    <span v-else class="text-danger">Absent</span>

                </td> -->
        <!-- <td>
                    {{
                        attendanceData.attendanceRecords[student.id] ?
                            $convertTo12Hour(attendanceData.attendanceRecords[student.id].time) : ''
                    }}
                </td> -->
        <!-- </tr>
        </table> -->

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Date</th>
                    <th colspan="100%">{{ $formatDate(date) }}</th>
                </tr>
                <tr>
                    <th>Time Slots</th>
                    <th v-for="slot in timeSlots" :key="slot.id" rowspan="2" style="vertical-align: top;">
                        {{ $convertTo12Hour(slot.start_time) }} - {{ $convertTo12Hour(slot.end_time) }}
                    </th>
                </tr>
                <tr>
                    <th> Name</th>
                    <!-- <th v-for="slot in timeSlots" :key="slot.id">
                        If present in time slot then show signature, else show status
                    </th> -->
                </tr>
            </thead>
            <tbody>
                <tr v-for="student in attendanceData.students" :key="student.id">
                    <td>{{ student.user?.name }}</td>
                    <td v-for="slot in timeSlots" :key="slot.id">
                        <img :src="student.signature_url" style="width: 200px;"
                            v-if="getAttendance(student.id, slot.id)?.status === 'present'" alt="present" />
                        <!-- <span v-if="=== 'present'">✔️</span> -->
                        <span style="color: green;"
                            v-else-if="getAttendance(student.id, slot.id)?.status === 'Appointment Scheduled'">
                            Appointment Scheduled
                        </span>
                        <span v-else>{{ getAttendance(student.id, slot.id)?.status }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            date: new Date().toISOString().split('T')[0],
            // date: '2025-02-17',
            selectedCounselor: '2',
            selectedGroup: '0',
            loading: false,
            counselors: [],
            groups: [],
            attendanceData: [],
            timeSlots: [],
        };
    },
    methods: {
        takeAttendance() {
            this.$router.push('/dashboard/attendance');
        },
        getAttendance(studentId, slotId) {
            return Object.values(this.attendanceData.attendanceRecords).find(
                record => record.student_id === studentId && record.time_slot_id === slotId
            );
        },
        loadAttendance() {
            this.loading = true;
            this.attendanceData = [];

            this.$api.post(`/attendance/filter`,
                {
                    // 'group_id': this.selectedGroup,
                    // 'counselor_id': this.selectedCounselor,
                    'date': this.date,
                    'unformatted': true,
                    group_id: this.selectedGroup,
                }).then((response) => {
                    this.attendanceData = response.data; // JSON object, not an array



                }).finally(() => {
                    this.loading = false;
                });
        },
        loadCounselors() {
            this.$api.get('/counselors')
                .then(response => {
                    this.counselors = response.data;
                })
                .catch(error => {
                    console.error('Error loading counselors:', error);
                });
        },
        loadGroups() {
            this.$api.get('/groups')
                .then(response => {
                    this.groups = response.data;
                })
                .catch(error => {
                    console.error('Error loading groups:', error);
                });
        },
        fetchTimeSlots() {
            this.$api.get("/time-slots").then((response) => {
                this.timeSlots = response.data;
            }).catch(error => {
                console.error("Error fetching time slots", error);
            });
        },

    },
    mounted() {
        // this.loadCounselors();
        this.loadGroups();
        this.fetchTimeSlots();
    }
};
</script>

<style>
.attendance-container {
    /* max-width: 800px; */
    margin: auto;
    background-color: white;

}

.loading-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}

.spinner {
    width: 30px;
    height: 30px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top-color: #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.table-bordered th,
.table-bordered td {
    border: 2px solid #a19b9b !important;
    /* Adjust thickness & color */
}
</style>